// extracted by mini-css-extract-plugin
module.exports = {"fetcherresults":"FetcherResults_fetcherresults__odSPV","fetcherresults-title":"FetcherResults_fetcherresults-title__xjTs2","mod-documents":"FetcherResults_mod-documents__j60JY"};